import React, { Component } from 'react';
import * as bActs from '../actions/blog-actions';
import * as wActs from '../actions/website-actions';
import {Link} from 'react-router-dom'
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import { FormattedDate } from 'react-intl';
import Pager from "../components/pager";
import SideBanners from "../components/sidebanners";
import * as wConsts from "../consts/website-consts";

class BlogList extends Component {

  componentDidMount() {
    this.props.dispatch(bActs.GetBlogPosts());
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "blog" });
  }

  render() {

    let blogList = () => {
      return (
        <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
          <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
        </p>
      );
    };

    if(this.props.Loaded && this.props.Code === 200) {



      blogList = () => {
        //console.log(this.props);
        return this.props.Posts.map((v,i) => {
          const bLink = this.props.WebPage.Settings.BlogPath + "/" + v.Slug;
          console.log(bLink)
          return (


            <div className="blog-wrapper">
              <article className="article-item single">
                <Link to={bLink} rel="bookmark">
                <h2 className="article-title">{v.Title}</h2>
                </Link>
                <div className="article-meta">
                  <div className="postdate left" style={{lineHeight: "22px"}}><i className="far fa-user"></i>&nbsp;{v.Author.Name}<br/><i className="far fa-clock"></i>&nbsp;<FormattedDate value={v.PublishedDate} weekday="long" day="2-digit" month="long" year="numeric"  /></div>
                  {v.Categories.length>0 &&
                  <div className="tags-wrapper right">
                    <i className="fas fa-tag"></i>
                    {v.Categories.map((cv,i) => { return <span style={{margin: "2px", color: "#656669"}} key={cv.Slug}>{cv.Name}</span>})}
                  </div>
                  }
                </div>

                {bActs.showImage(v.Image.Width, v.Image.Height) &&
                <div className="image"><Link to={bLink} rel="bookmark"><img style={{marginTop: "10px", minWidth: "100%"}} src={v.Image.Url.replace("_source", "_max")} alt={v.Title} /></Link></div>
                }


                {typeof window !== "undefined" &&
                <p style={{marginTop: "10px"}} dangerouslySetInnerHTML={{__html: v.Summary}}></p>
                }
              </article>
            </div>
          );
        });
      }
    }



    return (
      <div className="">
        <SeoHeaders Position={"Top"}/>
        <div className="">
          <div className="row">
            <div className="col_80">
              <div className="white-box the-content">
              {blogList()}
              {this.props.Loaded && this.props.Code === 200 &&
              <div className="row">
                <Pager ShowPages={3} Page={this.props.BlogList.Result.Context.Page} TotalPages={this.props.BlogList.Result.Context.TotalPages} />
              </div>
              }
              </div>
            </div>
            <SideBanners/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website,
    BlogList: state.Blog.BlogList,
    Posts: state.Blog.BlogList.Result.Result,
    Loaded: state.Blog.BlogList.Loaded,
    Code: state.Blog.BlogList.Result.Code,
  };
}

export default connect(mapStateToProps)(BlogList);
